// extracted by css-extract-rspack-plugin
export default {"variationDisplay":"fbVJ1iCZMA8UD23g"};